import { deleteData, getData, postData } from "./base-api";
import ApiUris from "./apiUris";

/**
 * sortable Column Api  method declarations
 */
export const sortableColumnApi = {
  getSortableColumn(request) {
    return postData(ApiUris.sortableColumnApi.getSortableColumn, request);
  },
  createSortableColumn(request) {
    return postData(ApiUris.sortableColumnApi.createSortableColumn, request);
  },
  editSortableColumn(request) {
    return postData(ApiUris.sortableColumnApi.updateSortableColumn, request);
  },
  deleteSortableColumn(request) {
    return deleteData(ApiUris.sortableColumnApi.deleteSortableColumn, request);
  },
};
